import { Box, Typography } from "@mui/material";

type Props = {
  values: Array<{ label: string; value?: string | null }>;
};

export const ValueItems = ({ values }: Props) => (
  <>
    {values.map(({ label, value }) => (
      <Box key={label} display="flex" justifyContent="space-between">
        <Typography fontWeight={400}>{label}</Typography>
        <Typography fontSize={16} fontWeight={500}>
          {value || "-"}
        </Typography>
      </Box>
    ))}
  </>
);
